/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PartsObjDto } from './partsObjDto';


export interface ListMultiPartDto { 
    listPartsObj: Array<PartsObjDto>;
}

